import React, { useEffect } from "react";
import { api, fmtNum } from "@finance/lib/api";
import { Input } from "@finance/components/ui/input";

// Mandatory FX rate for a foreign-currency document: pre-filled with the latest saved rate, editable, live ≈ TZS preview.
export function FxRateField({ currency, value, onChange, amount, testid = "fx-rate", prefill = true }) {
  const foreign = currency && currency !== "TZS";
  useEffect(() => {
    if (!foreign || !prefill || value) return;
    api.get("/forex-rates", { params: { currency, limit: 1 } }).then((r) => { if (r.data?.[0]?.rate) onChange(String(r.data[0].rate)); }).catch(() => {});
  }, [currency]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!foreign) return null;
  const rate = Number(value) || 0;
  return (
    <div data-testid={`${testid}-wrap`}>
      <div className="lx-label">FX rate (TZS per 1 {currency}) <span className="text-red-500">*</span></div>
      <Input type="number" step="0.0001" className="mt-1" data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={`e.g. 2650`} />
      {amount != null && <div className="mt-1 text-xs text-gray-500" data-testid={`${testid}-preview`}>≈ TZS {rate > 1 ? fmtNum(Number(amount) * rate) : "—"}</div>}
    </div>
  );
}
